<form [formGroup]="configurationFormFTP">
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="url" class="control-label required">{{'i18n.domain.export-configuration.configurations.forms.ftp.form-fields.url' | translate}}</label>
      <input id="url"
             type="url"
             class="form-control"
             formControlName="url"/>
      <app-error-messages [control]="configurationFormFTP.get('url')"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label for="port" class="control-label required">{{'i18n.domain.export-configuration.configurations.forms.ftp.form-fields.port' | translate}}</label>
      <input id="port"
             type="number"
             class="form-control"
             formControlName="port"/>
      <app-error-messages [control]="configurationFormFTP.get('port')"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label for="clientType" class="control-label required">{{'i18n.domain.export-configuration.configurations.forms.ftp.form-fields.ftp-type' | translate}}</label>
      <app-enum-drop-down-list formControlName="clientType"
                               [showClearButton]="false"
                               [enumType]="FTPClientType"
                               baseTranslationString='i18n.shared.ftpClientTypes.'>
      </app-enum-drop-down-list>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="userName" class="control-label required">{{'i18n.domain.export-configuration.configurations.forms.ftp.form-fields.username' | translate}}</label>
      <input id="userName"
             type="text"
             class="form-control"
             formControlName="userName"/>
      <app-error-messages [control]="configurationFormFTP.get('userName')"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label for="password" class="control-label {{configurationFormFTP.get('password').validator ? 'required' : ''}}">{{'i18n.domain.export-configuration.configurations.forms.ftp.form-fields.password' | translate}}</label>
      <input id="password"
             type="password"
             class="form-control"
             formControlName="password"
             autocomplete="new-password"
             appPasswordVisibility/>
      <app-error-messages [control]="configurationFormFTP.get('password')"></app-error-messages>
    </div>
    <div class="form-group col-md-4">
      <label for="relativePathOfFiles" class="control-label required">{{'i18n.domain.export-configuration.configurations.forms.ftp.form-fields.relative-path-for-files' | translate}}</label>
      <input id="relativePathOfFiles"
             type="text"
             class="form-control"
             formControlName="relativePathOfFiles"/>
      <app-error-messages [control]="configurationFormFTP.get('relativePathOfFiles')"></app-error-messages>
    </div>
  </div>
  <div class="form-row row">
    <div class="form-group col-md-4">
      <label for="useCertificate" class="control-label">{{'i18n.domain.export-configuration.configurations.forms.ftp.form-fields.use-certificate' | translate}}</label>
      <app-yes-no-group-button id="useCertificate"
                               formControlName="useCertificate"
                               i18nTranslationKeyPrefix="i18n.domain.export-configuration.configurations.yes-no-fields.has-certificate">
      </app-yes-no-group-button>
    </div>
  </div>
  @if (configurationFormFTP.get('useCertificate').value) {
    <div class="form-row row">
      <div class="form-group col-md-4">
        <label for="certificateMediaName" class="control-label required">{{'i18n.domain.export-configuration.configurations.forms.ftp.form-fields.certificate-name' | translate}}</label>
        <input id="certificateMediaName"
               type="text"
               class="form-control"
               readonly
               placeholder="{{'i18n.domain.export-configuration.configurations.forms.ftp.form-fields.certificate-name-placeholder' | translate}}"
               formControlName="certificateMediaName"/>
      </div>
      <div class="form-group col-md-4">
        <label for="certificateMedia" class="control-label">{{'i18n.domain.export-configuration.configurations.forms.ftp.form-fields.button-new-certificate' | translate}}</label>
        <ejs-uploader #defaultupload
                      id="certificateMedia"
                      allowedExtensions=".cer,.pfx,.ppk,.p7b,.p7c,.pem,.pub"
                      multiple="false"
                      [autoUpload]="false"
                      (selected)="onFileSelected($event)"
                      (removing)="onFileRemove()">
        </ejs-uploader>
      </div>
      <div class="form-group col-md-4">
        <label for="certificatePassword" class="control-label">{{'i18n.domain.export-configuration.configurations.forms.ftp.form-fields.certificatePassword' | translate}}</label>
        <input id="certificatePassword"
               type="password"
               class="form-control"
               formControlName="certificatePassword"
               autocomplete="new-password"
               appPasswordVisibility/>
      </div>
    </div>
  }
  <div class="form-row row">
    <div class="form-group col-md-12 d-flex align-items-center">
      <button type="button"
              [disabled]="!configurationFormFTP.valid"
              (click)="testFtpAccess()"
              class="btn btn-outline-secondary">
        {{'i18n.domain.export-configuration.configurations.forms.ftp.form-fields.button-test-ftp' | translate}}
      </button>
      <div class="ms-2">
        @if (isTestingConnection) {
          <div class="spinner-border spinner-border-sm me-3" role="status"></div>
        }
        @if (!isTestingConnection && ftpAccess) {
          <div class="d-flex align-items-center">
            @if (ftpAccess.succeeded) {
              <span class="text-success">{{'i18n.domain.export-configuration.configurations.forms.ftp.connection-success' | translate}}</span>
            }
            @if (!ftpAccess.succeeded) {
              <span class="text-danger">{{'i18n.domain.export-configuration.configurations.forms.ftp.connection-failed' | translate}}</span><br>
              <span class="text-danger">{{getErrorMessage}}</span>
              <span class="ms-2 icon-document log-icon cursor-pointer" (click)="showLog()"></span>
            }
          </div>
        }
      </div>
    </div>
  </div>
</form>
<ejs-dialog #dialog
            [isModal]="true"
            [showCloseIcon]="true"
            [visible]="false">
  <ng-template #header>
    Logfile
  </ng-template>

  <ng-template #content>
    <pre>{{formattedLog}}</pre>
  </ng-template>
  <ng-template #footerTemplate>
    <ng-container>
      <button class="btn btn-secondary me-2" (click)="closeLog()">{{'i18n.shared.close' | translate}}</button>
    </ng-container>
  </ng-template>
</ejs-dialog>
